<template>
  <div style="width: 100%; height: 100% ;box-sizing: border-box; padding: 10px;">
    <div class="page_title" style="margin-top:10px">
      <div class="page_title_desc">陕西延长石油集团横山魏墙煤业有限公司数据可视化看板</div>
      <div class="page-header-time">
        <!-- <span>数据更新时间：</span>
        <span class="refreshTime">{{ refreshTime }}</span>
        <span>（{{ countDownTime }}）</span> -->
        <el-button size="small" type="primary" @click="refreshPage"
          >刷新</el-button
        >
      </div>
    </div>
    <el-divider ></el-divider>
    <div class="container">
      <div class="map-container">
        <div id="map_container"></div>
        <div class="map-legend">
          <!-- <div id="barCharts" class="bar-charts"></div> -->
          <div class="status" v-for="item in carInfo" :key="item.status">
            <span><p :style="{background:item.color}"></p>{{item.statusName}}</span>
            <span style="font-size:18px">{{item.num}}</span>
          </div>
        </div>
      </div>
      <div class="fence-list">
        <div class="fence-list-header" >
          <div style="margin-bottom:10px">
            <el-input
            size="small"
            class="small-input"
            v-model="filterForm.carLicensePlateNo"
            placeholder="请输入车牌号"
            clearable
          ></el-input>
          <el-select
            size="small"
            class="small-input"
            v-model="filterForm.status"
            placeholder="请选择运单状态"
            filterable
            clearable
          >
            <el-option
              v-for="item in statusList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          </div>
          <div>
            <el-input
            size="small"
            class="small-input"
            v-model="filterForm.purchaseName"
            placeholder="请输入采购方名称"
            clearable
          ></el-input>
          <span ><el-button
            icon="fa fa-search"
            type="primary"
            @click="handleSearch"
            size="small"
            style="width:46%"
            >搜索</el-button
          >
          <el-button
            icon="fa fa-share"
            type="primary"
            size="small"
            style="width:46%"
            @click="handleReset"
            >重置</el-button
          ></span>
          </div>
        </div>
        <div class="fence-list-info">
          <div
            v-for="item in waybillList"
            :key="item.id"
            @click="focusFence(item)"
          >
            <el-card class="card-item">
              <!-- <div slot="header"> -->
              <!-- <el-button
                type="text"
                class="card-item-btn"
                @click="handleDel(item)"
                >删除</el-button
              > -->
              <!-- </div> -->
              <div class="card-item-desc">
                <span>车牌号：</span>
                <p>{{ item.carNo }}</p>
              </div>
              <div class="card-item-desc">
                <span>司机等级:</span>
                <p>{{ driverEnum[item.driverLevel] || "青铜司机" }}</p>
              </div>
              <div class="card-item-desc" v-if="item.forecastArriveTime">
                <span>预计到达时间：</span>
                <p>{{ item.forecastArriveTime }}</p>
              </div>
              <div class="card-item-desc">
                <span>运单状态:</span>
                <p>{{ item.statusName }}</p>
              </div>
              <div class="card-item-desc">
                <span>采购方:</span>
                <p>{{ item.purchaseName }}</p>
              </div>
              <div class="card-item-desc">
                <span>当前位置:</span>
                <p>{{ item.locationName }}</p>
              </div>
            </el-card>
          </div>
        </div>
        <div class="footer">
          <el-pagination
            style="width:100%;float: right;"
            background
            small
            layout="total, prev, pager, next"
            @current-change="refreshPageRequest"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="totalSize"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaiduMap from "@/utils/baidu-map.js";
import moment from "moment";

let map = null;
let drawingManager = null;
const opts = {
  width: 0,
  height: 0,
};

const redMarker = new BMap.Symbol(BMap_Symbol_SHAPE_CIRCLE, {
  scale: 3, //图标缩放大小
  fillColor: "#E94E4E", //填充颜色
  fillOpacity: 1, //填充透明度
  strokeOpacity: 1, //线透明度
  strokeColor: "#E94E4E",
});
const blueMarker = new BMap.Symbol(BMap_Symbol_SHAPE_CIRCLE, {
  scale: 3, //图标缩放大小
  fillColor: "#5268E4", //填充颜色
  fillOpacity: 1, //填充透明度
  strokeOpacity: 1, //线透明度
  strokeColor: "#5268E4",
});
const greenMarker = new BMap.Symbol(BMap_Symbol_SHAPE_CIRCLE, {
  scale: 3, //图标缩放大小
  fillColor: "#1EB859", //填充颜色
  fillOpacity: 1, //填充透明度
  strokeOpacity: 1, //线透明度,
  strokeColor: "#1EB859",
});

const redIcon = new BMap.Icon('https://ejiyun.obs.cn-north-4.myhuaweicloud.com/test/base/image/202207/62e22da2a00c68614d3a7177.png', new BMap.Size(33,23));
redIcon.imageSize = new BMap.Size(33,23)
const blueIcon = new BMap.Icon('https://ejiyun.obs.cn-north-4.myhuaweicloud.com/test/base/image/202207/62e22d8da00c68614d3a716d.png',new BMap.Size(33,23));
blueIcon.imageSize = new BMap.Size(33,23)
const greenIcon = new BMap.Icon('https://ejiyun.obs.cn-north-4.myhuaweicloud.com/test/base/image/202207/62e22b95a00c68614d3a7090.png',new BMap.Size(33,23) );
greenIcon.imageSize = new BMap.Size(33,23)

const driverEnum = {
  1: "青铜司机",
  2: "白银司机",
  3: "黄金司机",
};
import json from '../../utils/custom_map_config'
export default {
  data() {
    return {
      statusList: [],
      filterForm: {},
      waybillList: [],
      countDownTime: "0:00",
      refreshTime: "",
      countDownNo: 60 - 1,
      refreshTime: "",
      isEdit: false,
      statusInfoWindow: null, //infoWindow实例
      fenceInstanceList: [], //存放围栏实例 根据id查
      curFence: null,
      pageNo: 1,
      pageSize: 10,
      totalSize: null,
      driverEnum,
      barCharts:null,
      polygonStyle: {
        strokeColor: "#0066FF", //边线颜色。
        fillColor: "#0066FF", //填充颜色。当参数为空时，圆形将没有填充效果。
        strokeWeight: 2, //边线的宽度，以像素为单位。
        strokeOpacity: 0.8, //边线透明度，取值范围0 - 1。
        fillOpacity: 0.3, //填充的透明度，取值范围0 - 1。
        strokeStyle: "solid", //边线的样式，solid或dashed。
        enableEditing: false,
      },
      fence:null,
      carInfo:[]
    };
  },
  props: {},
  components: {},
  created() {},
  mounted() {
    
    window.addEventListener("resize", () => {
      this.barCharts && this.barCharts.resize()
    });
    this.$once('hook:beforeDestroy',()=>{
      clearInterval(this.countDownTimer);
      this.countDownTimer = null;
      // window.removeEventListener('resize',this.listenPageSizeChange())
    })
    this.getStatusList();
    this.handleSearch();
    this.mapInit();
    this.getAllDriver();
  },
  methods: {
    async getAllDriver() {
      let res = await this.$api.dataBoard.mGetCarData({});
      let statusEnum = {
        2: {
          desc: "已匹配",
          color: "#5268E4",
        },
        11: {
          desc: "已申请",
          color: "#E94E4E",
        },
        15: {
          desc: "已派单",
          color: "#1EB859",
        },
      };
      let arr = []
      Object.keys(res.data).forEach((key) => {
        arr.push({
          statusName: statusEnum[key]['desc'],
          num: res.data[key],
          status:key,
          color: statusEnum[key]['color'],
        })
      })
      let [x,y,z] = arr
      this.carInfo = [y,x,z]
      // let yAxisData = [];
      // let seriesData = [];
      // Object.keys(res.data).forEach((item) => {
      //   yAxisData.push(statusEnum[item]["desc"]);
      //   seriesData.push({
      //     value: res.data['item'],
      //     itemStyle: {
      //       color: statusEnum[item]["color"],
      //     },
      //   });
      // });
      // let option = {
      //   yAxis: {
      //     type: "category",
      //     data: yAxisData,
      //     axisLine: {
      //       show: false,
      //     },
      //     axisTick: {
      //       show: false,
      //     },
      //   },
      //   tooltip: {
      //     trigger: "axis",
      //     axisPointer: {
      //       type: "shadow",
      //     },
      //   },
      //   grid: {
      //     left: "10%",
      //     right: "4%",
      //     bottom: "10%",
      //     top: "12%",
      //     containLabel: true,
      //   },
      //   xAxis: {
      //     type: "value",
      //     show: false,
      //     axisLine: {
      //       show: false,
      //     },
      //     axisTick: {
      //       show: false,
      //     },
      //   },
      //   series: [
      //     {
      //       data: seriesData,
      //       type: "bar",
      //     },
      //   ],
      // };
      // const echart = this.$echarts.init(document.getElementById("barCharts"));
      // echart.setOption(option);
      // this.barCharts = echart
    },
    async getStatusList() {
      let res = await this.$api.waybill.mGetAllStatusList({});
      this.statusList = res.data.filter((item) => {
        return item.code == 2 || item.code == 11 || item.code == 15;
      });
    },
    async getDriverInfo() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.5)",
      });
      let res = await this.$api.dataBoard.mGetCarPoint({});
      this.driverInfo = res.data;
      setTimeout(() => {
        loading.close()
      }, 1000);
      
    },
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.handleSearch();
    },
    async handleSearch() {
      this.loading = true;
      const params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      let index = 0;
      for (let key in this.filterForm) {
        const val = this.filterForm[key];
        if (val === 0 || (val && val !== "")) {
          params["searchFieldList[" + index + "].fieldName"] = key;
          if (key === "signupTime") {
            params["searchFieldList[" + index + "].rangeMinValue"] = val[0];
            params["searchFieldList[" + index + "].rangeMaxValue"] = val[1];
          } else {
            params["searchFieldList[" + index + "].singleValue"] = val;
          }
          index++;
        }
      }
      let res = await this.$api.dataBoard.mGetCarDataList(params);
      
      this.waybillList = res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },
    handleReset() {
      this.filterForm = {};
      this.pageNo = 1;
      this.handleSearch();
    },
    countDownTimeFn(time) {
      this.countDownTimer && clearTimeout(this.countDownTimer);
      if (time == 0) {
        // this.getStatisticsData();
        this.handleSearch();
        this.mapInit();
        return "0:00";
      }
      let minute = Math.floor((time / 60) % 60);
      let seconds = Math.floor(time % 60);
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }
      time--;
      this.countDownTimer = setTimeout(() => {
        this.countDownTime = this.countDownTimeFn(time);
      }, 1000);
      return `${minute}:${seconds}`;
    },
    async mapInit() {
      //先请求list  然后init
      await BaiduMap.initVersion2();
      map = new BMap.Map("map_container", {
        enableMapClick: false,
        minZoom: 12,
        maxZoom: 16,
      });
      map.closeInfoWindow();
      map.enableScrollWheelZoom();
      let top_left_control = new BMap.ScaleControl({
        anchor: BMAP_ANCHOR_TOP_LEFT,
      }); // 左上角，添加比例尺
      let top_right_navigation = new BMap.NavigationControl({
        type: "BMAP_NAVIGATION_CONTROL_LARGE",
        anchor: BMAP_ANCHOR_TOP_RIGHT,
      }); //左上角，添加默认缩放平移控件
      map.addControl(top_left_control);
      map.addControl(top_right_navigation);
      map.centerAndZoom(
        new BMap.Point(109.2927400467526, 38.03244566917886),
        12
      );
      // map.setMapStyle(json)
      map.addEventListener('click',function(e){
          map.clearOverlays()
      })
      map.enableScrollWheelZoom();
      // this.countDownTime = this.countDownTimeFn(this.countDownNo);
      this.refreshTime = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
      await this.getDriverInfo();
      await this.renderFenceList(this.driverInfo);
      await this.renderFence()
      // this.addEventDraw()
    },
    handleDel(item) {
      this.$confirm("请确认是否删除该围栏，删除后不可恢复", "提示", {
        type: "warning",
      })
        .then((res) => {
          //删除接口
        })
        .catch((rej) => {});
    },
    async renderFence(){
      let res = await this.$api.dataBoard.mGetEnableFence({
        coalMineNo: 'K1030'
      })
      let fenceData = JSON.parse(res.data.fence);
      if (fenceData.length < 3) return;
      let fenceBMapArray = [];
      fenceData.map((item) => {
        fenceBMapArray.push(new BMap.Point(item.lng, item.lat));
      });
      this.fence = new BMap.Polygon(fenceBMapArray, this.polygonStyle);
      this.fence.disableMassClear()
      map.addOverlay(this.fence);
    },
    renderFenceList(data) {
      
      this.fenceInstanceList = [];
      Object.keys(data).map((key) => {
        // if(data[key].length) return
        data[key].forEach((item) => {
          let marker = new BMap.Marker(new BMap.Point(item.lng, item.lat), {
            icon: this.judgeIcon(key),
          });
          marker.disableMassClear()
          marker.addEventListener("click", () => {
            this.getPointInfo(item, true);
          });
          map.addOverlay(marker);
        });
      });
    },
    judgeIcon(item) {
      //两种情况 异常与非异常
      //[{"code":1,"name":"待支付"},{"code":11,"name":"已申请"},{"code":2,"name":"已匹配"},{"code":15,"name":"已派单"},{"code":3,"name":"已入场"},{"code":4,"name":"已出场"},{"code":5,"name":"已入矿"},{"code":6,"name":"已出矿"},{"code":13,"name":"已入站"},{"code":16,"name":"已领单"},{"code":14,"name":"已出站"},{"code":7,"name":"已取消"},{"code":8,"name":"已驳回"}]
      // if(item.locStatus){
      switch (item) {
        case "11":
          return redIcon;
        case "15":
          return greenIcon;
        case "2":
          return blueIcon;
      }
    },
    async getPointInfo(item, boolean) {
      console.log(item);
      let info = item;
      if (boolean) {
        let res = await this.$api.dataBoard.mGetCarInfo({
          waybillNo: item.waybillNo,
          lat: item.lat || 0,
          lng: item.lng || 0,
        });
        info = res.data;
      }
      if(!info.lat||!info.lng){
        this.$message({
          type:'error',
          message:'当前运单定位有误！',
          offset:300
        })
        return
      }
      
      map.panTo(new BMap.Point(info.lng, info.lat), 12);
      let infoWindow = new BMap.Label(
        `<div style="font-size:12px">
        <p style='font-size:16px;font-weight:bold;margin:0 0 10px'>车辆详情</p>
        <p style="margin:0">车牌号：${
          info.carNo
        }</p><p style="margin:0">司机等级：${
          driverEnum[info.driverLevel] || '青铜司机'
        }</p>${info.forecastArriveTime ? "<span>预计到场时间："+ info.forecastArriveTime +"</span>" : ''}
        <p style="margin:0">运单状态：${
          info.statusName
        }</p><p style="margin:0">采购方：${
          info.purchaseName
        }</p><p style="margin:0">当前位置：${info.locationName}</p></div>`,
        {
          ...opts,
          offset: new BMap.Size(15 ,10),
          position: new BMap.Point(info.lng, info.lat)
        }
      );
      infoWindow.setStyle({
        borderRadius: '10px',
        borderColor :'#fff',
        padding:'10px 10px',
        boxShadow: '0 2px 5px  rgba(0,0,0,0.15)'

      })
      map.clearOverlays()
      map.addOverlay(infoWindow);
    },
    async focusFence(item, type) {
      console.log(item);
      let res = await this.$api.dataBoard.mGetCarInfo({
        waybillNo: item.waybillNo,
        lat: item.lat || 0,
        lng: item.lng || 0,
      });
      let info = res.data;
      if(!info.lat||!info.lng){
        this.$message({
          type:'error',
          message:'当前运单定位有误！',
          offset:300
        })
        return
      }
      map.enableScrollWheelZoom();
      this.getPointInfo(info);
      
    },
    refreshPage() {
      this.$router.go(0);
    },
    
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 85%;
  display: flex;
  .map-container {
    width: 70%;
    height: 100%;
    position: relative;
    #map_container {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  .fence-list {
    flex: 1;
    height: 100%;
    overflow-y: auto;
  }
  .fence-list-header{
    position: sticky;
    z-index: 99;
    top: 0;
    background: #fff;
    box-sizing: border-box;
    padding: 6px 10px;
    div{
      display: flex;
      justify-content: space-between;
      span{
        width: 46%;
        display: flex;
        justify-content: space-between;
      }
    }
  }
}
.fence-list-info {
  width: 100%;
  box-sizing: border-box;
  padding:0 10px 30px;
  .card-item {
    width: 100%;
    margin: 10px 0;
    position: relative;
    .card-item-btn {
      position: absolute;
      right: 10px;
      color: red;
      text-decoration: underline;
    }
    .card-item-desc {
      width: 100%;
      display: flex;
      align-items: center;
      font-size: 12px;
      height: 20px;
      margin-bottom: 4px;
      span {
        width: 90px;
      }
      p{
        margin: 0;
        flex: 1;
      }
    }
  }
}
::v-deep .BMap_stdMpPan {
  display: block;
}
::v-deep .BMap_stdMpZoom {
  top: 50px;
}
::v-deep .BMap_scaleCtrl {
  inset: auto auto 30px 100px !important;
}
::v-deep .el-card{
  box-shadow: 1px 3px 5px 0 rgb(0 0 0 / 5%)
}
::v-deep .el-button{
  span{
    margin-left: 5px;
  }
}
.refreshTime {
  color: red;
}
.footer {
  position: absolute;
  bottom: 0;
  background: #fff;
  width: 25%;
  text-align: right;
}
.map-legend {
  width: 280px;
  height: 100px;
  position: absolute;
  background: #fff;
  opacity: 0.8;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .status{
    width: 30%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    span{
      margin-top: 10px;
      display: flex;
      align-items: center;
      p{
        margin: 0 5px;
        width: 10px;
        height: 10px;
      }
    }
  }
  .bar-charts {
    width: 100%;
    height: 100%;
  }
}
.small-input{
  width: 46%;
}
</style>